import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import styled from 'styled-components'
import get from 'lodash/get'
import set from 'lodash/set'
import { Container, Row, Col } from 'reactstrap'
import { css } from '@emotion/core'
import { BeatLoader } from 'react-spinners'
import moment from '../../lib/moment.js'
import {
  modalAction,
  authAction,
  standardCostAndPriceAction,
} from './../../actions'
import {
  modalSelector,
  authSelector,
  standardCostPriceSelector,
} from './../../selectors'
import {
  SearchBar,
  StandardCostPriceTable,
  EditStandardCostPrice,
} from '../../components/standard-cost-price'
import { generateButton } from '../../components/standard-cost-price/helpers/button'
import CustomModalMessage from '../../components/modal-message'
import withLayout from '../../helpers/withLayout'

class StandardCostAndPricePage extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const access_token = localStorage.getItem('access_token')
    const tempState = prevState
    if (get(nextProps, 'getStandardCostPriceData.standardCostPrices')) {
      const list = get(nextProps, 'getStandardCostPriceData.standardCostPrices')
      const standardCostPriceList = []
      list.map(cost => {
        let newCost = {}
        newCost = cost
        newCost.cost_number = parseFloat(cost.cost)
        newCost.price_number = parseFloat(cost.price)
        newCost.wmd = parseFloat(cost.wmd)
        newCost.sga_price = cost.sga_price ? parseFloat(cost.sga_price) : 0
        newCost.sga_support_price = cost.sga_support_price ? parseFloat(cost.sga_support_price) : 0
        standardCostPriceList.push(newCost)
        return cost
      })
      set(tempState, 'standardCostPrices', standardCostPriceList)
      nextProps.resetGetStandardCostPrice()
    }
    if (get(nextProps, 'createStandardCostPriceData.createdStandardCostPrice')) {
      const standardCostPrice = get(nextProps, 'createStandardCostPriceData')
      if (get(standardCostPrice, 'status') === 200) {
        nextProps.showConfirm('createCost', get(standardCostPrice, 'status'), get(standardCostPrice, 'message'))
        nextProps.getStandardCostPrice(access_token)
      } else {
        nextProps.showConfirm('createCost', 'Error', get(standardCostPrice, 'message'))
      }
      nextProps.resetCreateStandardCostPrice()
    }
    if (get(nextProps, 'editStandardCostPriceData.updatedStandardCostAndPrice')) {
      const updatedCost = get(nextProps, 'editStandardCostPriceData')
      if (get(updatedCost, 'status') === 200) {
        nextProps.showConfirm('updateCost', get(updatedCost, 'status'), get(updatedCost, 'message'))
        nextProps.getStandardCostPrice(access_token)
      } else {
        nextProps.showConfirm('updateCost', 'Error', get(updatedCost, 'message'))
      }
      nextProps.resetEditStandardCostPrice()
    }
    if (get(nextProps, 'exportStandardCostPriceData')) {
      window.open(get(nextProps, 'exportStandardCostPriceData'))
      nextProps.resetExportStandardCostPrice()
    }
    return tempState
  }

  state={
    rowID: '',
    isSpan: false,
    isEdit: false,
    searchStandardCostPrice: '',
    standardCostPrices: [],
    employee_level: '',
    wmd: 0,
    sga_price: 0,
    sga_support_price: 0,
    cost: 0,
    price: 0,
    start_date: moment(),
    end_date: moment(),
  }

  componentDidMount() {
    const access_token = localStorage.getItem('access_token')
    this.props.getAuth(access_token)
    this.props.getStandardCostPrice(access_token)
  }

  handleSearch = (e) => {
    this.setState({ searchStandardCostPrice: e })
  }

  clickRow = (rowID, standard) => {
    this.setState({
      isEdit: false,
      isSpan: true,
      rowID,
      standard,
      employee_level: get(standard, 'employee_level', '-'),
      cost: get(standard, 'cost', 0),
      price: get(standard, 'price', 0),
      wmd: get(standard, 'wmd', 0),
      sga_price: get(standard, 'sga_price', 0),
      sga_support_price: get(standard, 'sga_support_price', 0),
      start_date: get(standard, 'start_date') ? moment(standard.start_date) : moment(),
      end_date: get(standard, 'end_date') ? moment(standard.end_date) : moment(),
    })
  }

  clickEdit = (type) => {
    if (type === 'cancel') {
      this.setState({
        employee_level: this.state.standard.employee_level,
        wmd: this.state.standard.wmd,
        sga_price: this.state.standard.sga_price,
        sga_support_price: this.state.standard.sga_support_price,
        cost: this.state.standard.cost,
        price: this.state.standard.price,
        start_date: moment(this.state.standard.start_date),
        end_date: moment(this.state.standard.end_date),
      })
    }
    this.setState({ isEdit: !this.state.isEdit })
  }

  editStandardCostPrice = () => {
    const id = this.state.standard._id
    const payload = {}
    payload.employee_level = this.state.employee_level
    payload.start_date = this.state.start_date
    payload.end_date = this.state.end_date
    payload.cost = this.state.cost
    payload.price = this.state.price
    payload.wmd = this.state.wmd
    payload.sga_price = this.state.sga_price
    payload.sga_support_price = this.state.sga_support_price
    this.props.editStandardCostPrice(id, payload, localStorage.getItem('access_token'))
    this.setState({ isEdit: !this.state.isEdit })
  }

  discardCost = (type) => {
    if (type === 'discard') {
      this.setState({
        isEdit: !this.state.isEdit,
        isSpan: !this.state.isSpan,
        rowID: '',
      })
    }
    this.props.hideConfirm('discardCost')
  }

  handleEditInput = (e, type) => {
    if (type === 'start_date') this.setState({ start_date: e })
    else if (type === 'end_date') this.setState({ end_date: e })
    else this.setState({ [e.target.name]: e.target.value })
  }

  handleClose = () => {
    if (this.state.isEdit) {
      this.props.showConfirm('discardCost', 'Discard', 'Are you sure you want to discard all changes ?')
    } else {
      this.setState({
        isSpan: !this.state.isSpan,
        rowID: '',
      })
    }
  }

  selectButton = (confirmStatus, confirmType) => {
    if (confirmStatus === 200) return generateButton('success', () => this.props.hideConfirm(confirmType))
    else if (confirmStatus === 'Discard') return generateButton('discard', (type) => this.discardCost(type))
    else if (confirmStatus === 'Error') return generateButton('error', () => this.props.hideConfirm(confirmType))
    return null
  }

  filterStandardCostPrice = () => {
    const search = this.state.searchStandardCostPrice.toLowerCase()
    let standardCostPrices = this.state.standardCostPrices
    if (search !== '') {
      standardCostPrices = standardCostPrices.filter((cost) => {
        return cost.employee_level.toLowerCase().includes(search)
      })
    }
    return standardCostPrices
  }

  render() {
    const isFetching = get(this.props, 'getIsFetching')
    const confirmType = get(this.props, 'confirmType')
    const confirmStatus = get(this.props, 'confirmStatus')
    const confirmMessage = get(this.props, 'confirmMessage')
    const IsSystemUser = get(this.props, 'authData.user.is_system_admin')
    const IsHRConfidentialUser = get(this.props, 'authData.user.is_hr_admin_confidential_role')

    const isAuthenticated = get(this.props, 'redirectAuth.isAuthenticated')
    || get(this.props, 'redirectStandardCostPrice.isAuthenticated')
    const redirect = get(this.props, 'redirectAuth.redirect')
      || get(this.props, 'redirectStandardCostPrice.redirect')
    if (redirect) {
      localStorage.clear()
      if (isAuthenticated) localStorage.setItem('bad_token', true)
      this.props.resetAuth()
      window.location = '/'
    }

    if (IsSystemUser !== undefined &&
      IsHRConfidentialUser !== undefined &&
      !(IsSystemUser || IsHRConfidentialUser)) window.location = '/home'
    return (
      /* eslint no-underscore-dangle: 0 */
      <Wrapper fluid>
        { isFetching &&
          <Overlay>
            <OverlayWrapper>
              <BeatLoader
                css={ css(`
                  position: absolute;
                  left: 50%;
                  top: 50%;
                `) }
                sizeUnit={ "px" }
                size={ 15 }
                color={ '#D44B49' }
                loading={ isFetching }
              />
            </OverlayWrapper>
          </Overlay>
        }
        <CustomModalMessage
          hide={ () => this.props.hideConfirm(confirmType) }
          show={
            confirmType === 'createCost'
            || confirmType === 'updateCost'
            || confirmType === 'discardCost'
          }
          type={ confirmStatus }
          message={ confirmMessage }
          button={ this.selectButton(confirmStatus, confirmType) }
        />
        <SearchBar
          isEdit={ this.state.isEdit }
          handleClose={ this.handleClose }
          closeSpan={ () => this.setState({ isSpan: false, rowID: '' }) }
          handleSearch={ this.handleSearch }
          exportStandardCostPrice={ () => this.props.exportStandardCostPrice(localStorage.getItem('access_token')) }
          createStandardCostPrice={ (payload) =>
            this.props.createStandardCostPrice(payload, localStorage.getItem('access_token')) }
        />
        <Row noGutters>
          <Col>
            <StandardCostPriceTable
              rowID={ this.state.rowID }
              standardCostPrices={ this.filterStandardCostPrice() }
              clickRow={ this.clickRow }
            />
          </Col>
          { this.state.isSpan &&
            <Column>
              <EditStandardCostPrice
                employee_level={ this.state.employee_level }
                wmd={ this.state.wmd }
                sga_price={ this.state.sga_price }
                sga_support_price={ this.state.sga_support_price }
                cost={ this.state.cost }
                price={ this.state.price }
                start_date={ this.state.start_date }
                end_date={ this.state.end_date }
                isEdit={ this.state.isEdit }
                clickEdit={ this.clickEdit }
                handleEditInput={ this.handleEditInput }
                handleClose={ this.handleClose }
                editStandardCostPrice={ this.editStandardCostPrice }
              />
            </Column>
          }
        </Row>
      </Wrapper>
    )
  }
}

StandardCostAndPricePage.propTypes = {
  resetAuth: PropTypes.func.isRequired,
  showConfirm: PropTypes.func.isRequired,
  hideConfirm: PropTypes.func.isRequired,
  getAuth: PropTypes.func.isRequired,
  getStandardCostPrice: PropTypes.func.isRequired,
  createStandardCostPrice: PropTypes.func.isRequired,
  exportStandardCostPrice: PropTypes.func.isRequired,
  editStandardCostPrice: PropTypes.func.isRequired,
}
const mapStateToProps = (state, props) => createStructuredSelector({
  modalStatus: modalSelector.modalStatus,
  modalType: modalSelector.modalType,
  modalMessage: modalSelector.modalMessage,
  confirmStatus: modalSelector.confirmStatus,
  confirmType: modalSelector.confirmType,
  confirmMessage: modalSelector.confirmMessage,
  authData: authSelector.getAuth,
  redirectAuth: authSelector.redirectAuth,
  redirectStandardCostPrice: standardCostPriceSelector.redirectStandardCostPrice,
  getIsFetching: standardCostPriceSelector.getIsFetching,
  getStandardCostPriceData: standardCostPriceSelector.getStandardCostPriceData,
  createStandardCostPriceData: standardCostPriceSelector.createStandardCostPriceData,
  editStandardCostPriceData: standardCostPriceSelector.editStandardCostPriceData,
  exportStandardCostPriceData: standardCostPriceSelector.exportStandardCostPriceData,
})(state, props)
const mapDispatchToProps = dispatch => bindActionCreators({
  showModal: modalAction.showModal,
  hideModal: modalAction.hideModal,
  showConfirm: modalAction.showConfirm,
  hideConfirm: modalAction.hideConfirm,
  getAuth: authAction.auth,
  resetAuth: authAction.resetAuthUser,
  getStandardCostPrice: standardCostAndPriceAction.getStandardCostPrice,
  resetGetStandardCostPrice: standardCostAndPriceAction.resetGetStandardCostPrice,
  createStandardCostPrice: standardCostAndPriceAction.createStandardCostPrice,
  resetCreateStandardCostPrice: standardCostAndPriceAction.resetCreateStandardCostPrice,
  editStandardCostPrice: standardCostAndPriceAction.editStandardCostPrice,
  resetEditStandardCostPrice: standardCostAndPriceAction.resetEditStandardCostPrice,
  exportStandardCostPrice: standardCostAndPriceAction.exportStandardCostPrice,
  resetExportStandardCostPrice: standardCostAndPriceAction.resetExportStandardCostPrice,
}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(withLayout(StandardCostAndPricePage))

const Wrapper = styled(Container)`
  padding: 0px;
`
const Column = styled(Col)`
  padding-left: 0px;
  padding-right: 0px;
`
const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
`
const OverlayWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`



// WEBPACK FOOTER //
// ./src/pages/standard-cost-price/index.js